import { OnChangeValue, ActionMeta } from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { OptionType, colourStyles } from './styleConfig';

interface PredictMultiSelectProps {
  defaultValue: OptionType[];
  options: OptionType[];
  onChange: (
    newValue: OnChangeValue<OptionType, true>,
    action: ActionMeta<OptionType>,
  ) => void;
  optionMessage?: () => string;
  createText?: string;
  aiGenerated: string[];
  disabled: boolean;
  hasError?: boolean;
  duplicateTags?: string[];
}

function PredictMultiSelect({
  defaultValue,
  options,
  onChange,
  optionMessage,
  createText = '',
  aiGenerated,
  disabled,
  hasError = false,
  duplicateTags = [],
}: PredictMultiSelectProps) {
  return (
    <CreatableSelect
      isMulti
      options={options}
      styles={colourStyles(
        disabled ? [] : aiGenerated,
        hasError,
        duplicateTags,
      )}
      defaultValue={defaultValue}
      onChange={onChange}
      placeholder=""
      noOptionsMessage={optionMessage}
      formatCreateLabel={(value) => `${createText} ${value}`}
      isDisabled={disabled}
    />
  );
}
export default PredictMultiSelect;
